import React from 'react'
import IActualite from 'model/actualite';
import ActualitesService from 'services/actualitesService';
import Header from 'components/common/header/header';
import Styles from "./actualite.module.scss";
import { Markup } from 'interweave';
import { Container } from 'reactstrap';
import { FacebookShareButton, FacebookIcon, TwitterShareButton, TwitterIcon } from 'react-share';

interface IActualiteProps {
    id: number;
    setHeaderValues: Function
}

interface IActualiteState {
    actu?: IActualite;
}

class Actualite extends React.Component<IActualiteProps, IActualiteState> {
    /**
     *
     */
    constructor(props: IActualiteProps) {
        super(props);

        this.state = { actu: undefined };
    }

    componentDidMount() {
        ActualitesService.GetActu(this.props.id).then((a: IActualite) => {
            this.setState({ actu: a });
            this.props.setHeaderValues({ headerPictureUrl: a.PictureUrl, headerTitle: a.Title, headerUrl: undefined });
        });
    }


    render() {
        if (this.state.actu) {
            let extraContent = [];
            extraContent.push(this.state.actu.IsEvent ? <div>Date : {this.state.actu.StartDate ? this.state.actu.StartDate.toLocaleString() : null} -  {this.state.actu.EndDate ? this.state.actu.EndDate.toLocaleString() : null}</div> : null);
            if (this.state.actu.Location)
                extraContent.push(<div>Lieu : {this.state.actu.Location}</div>);

            if (this.state.actu.Spectacles)
                extraContent.push(<div>Spectacles : {this.state.actu.Spectacles.map(s =>
                    <a href={`/#/spectacle/${s.Id}`}>{s.Title}</a>
                )}</div>);

            if (this.state.actu.Decors)
                extraContent.push(<div>Decors : {this.state.actu.Decors.map(d =>
                    <a href={`/#/decor/${d.Id}`}>{d.Title}</a>
                )}</div>);

            return <div className={Styles.Actualite}>
                <Container>
                    <div className="row">
                        <div className="col-12 col-lg-6">
                            <a href="/#/actualites">Voir toutes les actualités</a>
                            <div className="imgIllustration">
                                <img src={this.state.actu.PictureUrl} />
                            </div>
                        </div>
                        <div className="col-12 col-lg-6">
                            <p className="date">
                                {extraContent}
                            </p>
                            <p className="chapo">
                                {this.state.actu.Chapo}
                            </p>
                            <p className="content">
                                <Markup content={this.state.actu.Content} />
                            </p>

                            <div className="social">
                                <p>Partagez sur les réseaux sociaux :</p>
                                <div className="icons">
                                    <FacebookShareButton url={window.location.href} quote={encodeURIComponent(this.state.actu.Title)} hashtag={'#CieRelativement'} ><FacebookIcon size={32} round={true} /></FacebookShareButton>
                                    <TwitterShareButton url={window.location.href} title={this.state.actu.Title} hashtags={["CieRelativement"]} ><TwitterIcon size={32} round={true} /></TwitterShareButton>
                                </div>
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
        }
        else
            return null;
    }
}

export default Actualite;